import React, { useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { api, formatErr } from "../../lib/api";
import { btn } from "../leads/PriorityBadge";
import { localToday } from "../../lib/testLibrary";

export const RepeatForm = ({ a, onDone }) => {
  const [f, setF] = useState({ comment: "", due_date: localToday() });
  const go = () => api.post(`/admin/test-assignments/${a.id}/request-repeat`, f)
    .then(() => { toast.success("Nueva ejecución solicitada. El futbolista verá tu comentario."); onDone(); }).catch((e) => toast.error(formatErr(e)));
  return (
    <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap", alignItems: "flex-end" }} data-testid={`repeat-form-${a.id}`}>
      <label style={{ fontSize: 12, color: "#a3a3a3", flex: 1, minWidth: 220 }}>Qué debe repetir (lo verá el futbolista)
        <input className="qv-input" style={{ textTransform: "none" }} value={f.comment} onChange={(e) => setF({ ...f, comment: e.target.value })} data-testid={`repeat-comment-${a.id}`} />
      </label>
      <label style={{ fontSize: 12, color: "#a3a3a3" }}>Nueva fecha<input type="date" className="qv-input" value={f.due_date} onChange={(e) => setF({ ...f, due_date: e.target.value })} data-testid={`repeat-date-${a.id}`} /></label>
      <button style={btn("#dc2626")} disabled={f.comment.trim().length < 3} onClick={go} data-testid={`repeat-send-${a.id}`}><RotateCcw size={13} /> Solicitar</button>
    </div>
  );
};
